import {Alert, Button} from 'antd';
import {useMutation, useQuery} from 'react-query';
import api from '../../api';
import {queryClient} from '../../utils/react-query';


const InvitationSendingForm = ({...props}) => {
  const {data: {data: itemData = []} = {}} = useQuery(['meeting', props.meeting],
    async () => {
      return await api.meetings.meetingControlRetrieve(props.meeting);
    }, {
      enabled: !!props.meeting,
      refetchInterval: 10000,
      cacheTime: Infinity,
    });

  const {mutateAsync: mutateAsyncUpdate} = useMutation(
    api.meetings.meetingInvoiceActivateSending, {
      onSuccess: async () => {
        await queryClient.removeQueries(['meeting', props.meeting]);
      }
    });

  const startSending = async () => {
    await mutateAsyncUpdate({meetingId: props.meeting});
  }

  return <div>
    <h3 className="title">E-Mail schicken</h3>
    <hr className="hr"/>
    {itemData.invoice_sending_status === 'CREATED' &&
      <Button style={{marginBottom: '20px'}} onClick={startSending}>
        Rechnungen verschicken
      </Button>
    }

    {itemData.invoice_sending_status === 'READY' &&
      <>
        <Alert message="Rechnungen können versendet werden" type="info"
               style={{marginBottom: '20px'}}/>
      </>
    }

    {itemData.invoice_sending_status === 'PROCESSING' &&
      <>
        <Alert message="Rechnungen in Bearbeitung" type="info"
               style={{marginBottom: '20px'}}/>
      </>
    }

    {itemData.invoice_sending_status === 'COMPLETED' &&
      <>
        <Alert message="Rechnungen wurden verschickt" type="success"
               style={{marginBottom: '20px'}}/>
        <Button style={{marginBottom: '20px'}} onClick={startSending}>
        Rechnungen erneut versenden
        </Button>
      </>
    }

    <hr className="hr"/>

  </div>
}

export default InvitationSendingForm;